import { Col, Row, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import type { TabsProps } from 'antd';
import RejectionReasonsStandard from './rejection-reasons-standard';
import LanguageCode from 'src/shared/services/types/language-code';
import languageData from 'src/domain/core/AppLanguageSwitcher/data';
import RejectionReasonsLanguage from './rejection-reasons-language';

interface IRejectionReasonsInfoProps { }

const RejectionReasonsInfo = (props: IRejectionReasonsInfoProps) => {
  const { messages } = useIntl();

  const langComponent = [
    {
      code: `${LanguageCode.English}`,
      langComponent: (
        <RejectionReasonsLanguage code={LanguageCode.English} index={0} />
      ),
    },
    {
      code: `${LanguageCode.Español}`,
      langComponent: (
        <RejectionReasonsLanguage code={LanguageCode.Español} index={1} />
      ),
    },
    {
      code: `${LanguageCode.Arabic}`,
      langComponent: (
        <RejectionReasonsLanguage code={LanguageCode.Arabic} index={2} />
      ),
    },
  ];

  const itemsTab: TabsProps['items'] = [
    {
      key: 'standard',
      label: `${messages[
        'productRejectionReasons.create.titleTab'
      ].toString()}`,
      children: <RejectionReasonsStandard />,
    },
    ...languageData
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((language) => {
        return {
          key: language.code,
          label: (
            <>
              <Row gutter={7}>
                <Col>
                  <i className={`flag flag-24 flag-${language.icon}`} />
                </Col>
                <Col>
                  <h4 className='title-tab'>{language.name}</h4>
                </Col>
              </Row>
            </>
          ),
          children: (
            <>
              {langComponent && langComponent?.length > 0 ? (
                langComponent?.find((item) => item.code === language.code)
                  ?.langComponent ?? <></>
              ) : (
                <></>
              )}
            </>
          ),
        };
      }),
  ];
  return <Tabs defaultActiveKey='standard' items={itemsTab} />;
};

export default RejectionReasonsInfo;
